import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function productDescriptionLengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const obj = control.value;
    if (
      typeof obj === 'object' &&
      obj !== null &&
      typeof obj.name === 'string' &&
      obj.name.trim().length > 0 &&
      obj.name.length <= 100
    ) {
      return null;
    }
    return { productDescriptionLengthFailure: true };
  };
}
